// src/components/molecules/NewsCard.tsx
import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import tinycolor from 'tinycolor2';
import { CustomText, CustomImage } from '../atoms';

interface NewsCardProps {
  imageUrl?: string; // URL of the image
  title: string; // Title of the news card
  date: string; // Date to display
  bgColor: string | undefined; // Background color of the card
  secondaryAccentColor?: string; // Secondary accent color for the card (optional)
  newsHeadlineTextColor?: string;
  textColor?: string; // Text color of the card (optional, default is "black")
  id: string | number;
  //   onClickNewsItem: (id: string | number) => void;
  newsSectionHelperTextReadMore: string;
  onClickNewsArticlePreview: (id: string | number) => void;
}

export const NewsCardPreview: React.FC<NewsCardProps> = ({
  id,
  imageUrl,
  title,
  date,
  bgColor,
  secondaryAccentColor,
  newsHeadlineTextColor = 'white',
  textColor = 'black',
  //   onClickNewsItem,
  newsSectionHelperTextReadMore,
  onClickNewsArticlePreview,
}) => {
  // Adjust color for the date (lighter version of textColor)
  const dateColor = tinycolor(textColor).lighten(40).toString();
  return (
    <Flex
      borderWidth="1px"
      // borderRadius="lg"
      overflow="hidden"
      backgroundColor={bgColor}
      color={textColor}
      cursor="pointer"
      _hover={{ boxShadow: 'md', transform: 'scale(1.02)' }}
      onClick={() => onClickNewsArticlePreview(id)}
      direction="row"
      height="100%"
    >
      {/* Left Image (30%) */}
      <Box
        flex="0 0 30%"
        height="100%"
        maxW="240px"
        aspectRatio={{ base: 2 / 3, md: 2 / 3 }}
        overflow="hidden"
        p="2"
      >
        {imageUrl && (
          <CustomImage
            src={imageUrl}
            alt={title}
            objectFit="cover"
            width="100%"
            height="100%"
            border={`2px solid ${newsHeadlineTextColor}`}
            borderRadius="0"
          />
        )}
      </Box>

      {/* Right Content (70%) */}
      <Flex flex="0 0 70%" direction="column" p="4" gap="3">
        <CustomText variant="body" color={dateColor} fontSize="sm">
          {date}
        </CustomText>

        <Text fontWeight="bold" fontSize="md" noOfLines={4} color={newsHeadlineTextColor}>
          {title}
        </Text>
        <CustomText
          variant="body"
          fontSize="xs"
          fontWeight="bold"
          color={secondaryAccentColor}
          cursor="pointer"
          _hover={{ textDecoration: 'underline' }}
          onClick={() => onClickNewsArticlePreview(id)}
          mt="auto"
        >
          {newsSectionHelperTextReadMore}
        </CustomText>
      </Flex>
    </Flex>
  );
};
